import React, { Fragment } from "react";
import { Mail, PartTimeClock, SuitCase } from "../common/icons";
import styled from "styled-components";
import Button from "../common/Button";
import TopBox from "../common/TopBox";
import { RouteName } from "../../lib/routes";
import { ApiResult } from "../../lib/CmsApi";
import SectionListWithNav, {
  flattenCMSSectionLists,
  SectionWithNavLink
} from "../sections/SectionListWithNav";
import { media, spacing } from "../theme";
import Section from "../sections/Section";

const StyledButton = styled(Button)`
  ${spacing("margin-bottom", 24)}
  @media screen and ${media.tablet}{
    display:none;
  }
`;

export const JobList = styled.ul`
  list-style: none;
  align-self: flex-end;
  padding: 0;
  margin: 0;
  ${spacing("padding-bottom", 48)}
`;
export const JobEntry = styled.li`
  display: block;
  font-size: 0.8em;
  line-height: 1.6;
  margin: 0;
  ${spacing("margin-bottom", 16)}

  color:#fff;
  > svg {
    width: 1em;
    height: 1em;
    margin-right: 1ch;
  }
`;
const StyledMail = styled(Mail)`
  fill: #fff;
  margin-right: 1ch;
  flex-shrink: 0;
`;
const StyledButtonBottom = styled(Button)`
  ${spacing("margin-bottom", 64)}
`;

const InvisibleH2 = styled.h2`
  display: block;
  margin: 0;
  font-weight: 400;
`;

export type Props = ApiResult<"loadJobOfferBySlug">;
export default function CarrerJobOfferPage(props: Props) {
  const cmsSections = flattenCMSSectionLists(props.sections);
  return (
    <Fragment>
      <TopBox
        breadCrumpPath={[
          { route: "career" as RouteName, title: "Karriere" },
          {
            route: "careerLevel" as RouteName,
            title: props.category.name,
            params: { slug: props.category.slug }
          },
          {
            route: "jobOffer" as RouteName,
            title: props.name,
            params: { level: props.category.slug, slug: props.slug }
          }
        ]}
        overline="Stellenausschreibung"
        title={props.name}
        linearBackground
        noMargin
        infoBox={
          <JobList>
            <JobEntry>
              <SuitCase />
              <span>{props.employmentType}</span>
            </JobEntry>
            <JobEntry>
              <PartTimeClock />
              <span>{props.employmentSchema}</span>
            </JobEntry>
          </JobList>
        }
      />
      <SectionListWithNav
        limitContentWidth
        sections={
          [
            {
              _type: "Text",
              text: `<h2>${props.intro}</h2>`
            },
            ...(cmsSections || []),
            {
              navLink: "Bewerben",
              _type: "Custom",
              element: (
                <Section reducedSectionPadding>
                  <InvisibleH2>
                    <StyledButtonBottom
                      href={`mailto:karriere@ifbhh.de?subject=${props.name}`}
                      alignLeft
                    >
                      <StyledMail />
                      Jetzt bewerben
                    </StyledButtonBottom>
                  </InvisibleH2>
                </Section>
              )
            }
          ].filter(Boolean) as SectionWithNavLink[]
        }
        sidebar={() => (
          <>
            <StyledButton
              href={`mailto:karriere@ifbhh.de?subject=${props.name}`}
            >
              <StyledMail />
              Jetzt bewerben
            </StyledButton>
          </>
        )}
      />
    </Fragment>
  );
}

CarrerJobOfferPage.getImages = (p: Props) => {
  let images = [];
  const sections = flattenCMSSectionLists(p.sections);
  if (sections) {
    images = images.concat(SectionListWithNav.getImages({ sections }));
  }
  return images;
};
